import React from 'react'
import PasswordStrengthBar from 'react-password-strength-bar'
import { I18n } from 'shared/i18n/i18n'
import { FormInputProps } from './inputs'

const strengthDescriptions = {
  // the first two elements of these arrays are intentionally duplicated
  // otherwise the last strengthDescription disappears when the bar is full
  de: ['Schwaches Passwort', 'Schwaches Passwort', 'Mäßiges Passwort', 'Gutes Passwort', 'Starkes Passwort'],
  en: ['Weak password', 'Weak password', 'Fair password', 'Good password', 'Strong password'],
}

const shortScoreWord = {
  de: ['Passwort zu kurz'],
  en: ['Password too short'],
}

export const PasswordStrengthMeter = ({ form, field = 'password' }: FormInputProps) => {
  const password = form.values[field]
  return (
    <PasswordStrengthBar
      password={password}
      minLength={8}
      scoreWords={strengthDescriptions[I18n.locale === 'de' ? 'de' : 'en']}
      shortScoreWord={shortScoreWord[I18n.locale === 'de' ? 'de' : 'en']}
    />
  )
}
